import { useLoadingErrorCatcher } from '../hooks/useLoadingErrorCatcher';
import { createHOCWithHookInside } from './createHOCWithHookInside';

/**
 * @deprecated use "useLoadingErrorCatcher"
 */
export const withLoadingErrorCatcher = createHOCWithHookInside('WithLoadingErrorCatcher', useLoadingErrorCatcher);
